import { Route, Routes } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoute";
import { PublicRoutes } from "./PublicRoutes";
import { loginSelector } from "../redux/slices/loginSlice";
import { useSelector } from "react-redux";

function AppRoute() {
  const loginStore = useSelector(loginSelector);

  // Clean up Azure AD `code=` from the URL
  if (window.location.search.includes('code=')) {
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
  }

  // Show a loader until login status is confirmed
  if (loginStore.status === 'loading' || loginStore.status === 'idle') {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {loginStore.status === 'authenticated' ? (
        <Route path="/*" element={<PrivateRoutes />} />
      ) : (
        <Route path="/*" element={<PublicRoutes />} />
      )}
    </Routes>
  );
}

export default AppRoute;
